module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vega-lite', {
    attrs: {
      "mark": "bar",
      "data": _vm.values,
      "encoding": _vm.encoding
    }
  }), _c('button', {
    staticClass: "button button--medium",
    on: {
      "click": _vm.refreshNumbers
    }
  }, [_vm._v("Refresh")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3e7788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./_docs/partials/examples/UpdateDataExample.vue
// module id = 1640
// module chunks = 1